/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Returnairco2actualsetpoint5Inputs */



/**
* | output |
* | --- |
* | "Return air actual CO2 setpoint" |
*
* @param {Ahu_History_Key_Returnairco2actualsetpoint5Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_returnairco2actualsetpoint5 = /** @type {((inputs?: Ahu_History_Key_Returnairco2actualsetpoint5Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Returnairco2actualsetpoint5Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Return air actual CO2 setpoint")
	return /** @type {LocalizedString} */ ("Consigne réelle CO2 air reprise")
});
export { ahu_history_key_returnairco2actualsetpoint5 as "ahu_history_key_returnAirCO2ActualSetpoint" }